/* Плъзгач за сравнение на две изображения.
   Управлява се с истински <input type="range">, за да работи
   и с клавиатура, и с екранен четец, без допълнителен код. */
(function () {
  'use strict';

  function init(root) {
    var stages = (root || document).querySelectorAll('[data-lp-slider]');
    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.dataset.lpSliderOn === '1') return;
      stage.dataset.lpSliderOn = '1';

      var input  = stage.querySelector('[data-lp-slider-input]');
      var clip   = stage.querySelector('[data-lp-slider-clip]');
      var handle = stage.querySelector('[data-lp-slider-handle]');
      if (!input || !clip) return;

      function apply() {
        var v = input.value;
        clip.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        if (handle) handle.style.left = v + '%';
      }

      input.addEventListener('input', apply);
      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
